<template lang="pug">
	.insertion-validation
		.flex-col.space-large
			.flex-col.margin-bottom
				.flex-col.space-large.header-data
					.flex-row.justify.wrap.nav-header-wrapper
						.flex-col.nav-header.justify
							.flex-row.space.justify.align-center
								.left.flex-row.space.align-center
									a(@click="() => $router.push({ name: 'home' })") Adthos
									.spacer /
									span {{$tCaption('Validate insertion')}}
									.loader-holder.flex-row.align-center
										Loader(v-if="isLoading || (validationAvailable && !audioIsLoaded)" text="")
			.insertion-validation-editor
				.flex-col.space-large
					creativeDetail(
						v-show="false",
						ref="creativeDetail",
						:creativeId="creativeId",
						:disabled="true",
						@loaded="onTrackerLoaded",
						@creative-initialized="onCreativeInitialized"
					)
					template(v-if="audioIsLoaded")
						template(v-if="!validationAvailable")
							.font-big.no-valid {{$tCaption('The link for editng the creative CREATIVE_NAME is no longer valid.').replace('CREATIVE_NAME', creativeName)}}
						template(v-else-if="loadedSubInsertions.length")
							.flex-col.space-large
								.flex-row.justify.margin-bottom
									.left
										.font-big {{creativeName}}
									.right
										.flex-row.space-medium.align-center
											DxButton(
												v-if="playType !== 2 || !isPlaying",
												:text="$tCaption('Play mix')",
												type="default",
												icon="fas fa-play",
												:disabled="actionsDisabled"
												@click="playMix()",
											)
											Loader(
												v-if="isPlaying > 0 && playType === 2",
												text=""
											)
											DxButton(
												v-if="isPlaying && playType === 2",
												:text="$tCaption('Stop', '@actions')",
												type="normal", icon="fas fa-stop",
												@click="stopPlayMix"
											)
											DxButton(
												:text="$tCaption('Download')",
												icon="fas fa-download",
												:disabled="actionsDisabled"
												@click="downloadMix()",
											)
								.flex-col.space-medium(v-for="insertion in loadedSubInsertions")
									.flex-row.align-center.space-medium
										.flex-row.align-center
											DxButton(
												v-if="!isPlaying || !playingSubInsertionsId || playingSubInsertionsId !== insertion.Oid",
												type="default",
												stylingMode="text",
												:activeStateEnabled="false",
												:focusStateEnabled="false",
												icon="fas fa-play",
												:disabled="actionsDisabled"
												@click="playInsertion(insertion)",
											)
											DxButton(
												v-if="isPlaying && playType === 1 && playingSubInsertionsId === insertion.Oid",
												:activeStateEnabled="false",
												:focusStateEnabled="false",
												stylingMode="text",
												type="normal", icon="fas fa-stop",
												@click="stopPlaySubInsertions"
											)
											.flex-row.space.align-center
												.upper {{ insertion.Name }}
												.grey ({{`${formatTime(insertion.StartTime / 1000)} - ${formatTime((insertion.StartTime + insertion.Duration) / 1000)}`}})
											Loader(
												v-if="isPlaying && playType === 1 && playingSubInsertionsId === insertion.Oid || insertion.__isLoading",
												text=""
											)
										DxButton(
											v-if="!actionsDisabled && getCreativeTrack(insertion).insertion.Ssml !== insertion.Ssml",
											:text="$tCaption('Apply changes', '@actions')",
											icon="check",
											type="success",
											:disabled="insertion.__isLoading",
											@click="applyInsertionChanges(insertion)")
									JoditEditor.validation-ssml-editor(v-model="insertion.Ssml", :config="{ toolbar: false, statusbar: false, height: '100px', minHeight: '100px' }", :disabled="actionsDisabled")
									.flex-row.justify.space-large.wrap.layout-main
										.left
											.flex-row.space
											
											
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import AudioTracker from 'view/audioTracker/AudioTracker.vue';
	import creativeDetail from 'view/creative/Detail.vue';
	import VueTypes from "vue-types";
	import DxButton from 'devextreme-vue/button';	
	import JoditEditor from 'view/insertion/JoditEditor.vue';

	export default {
		translationCategory: 'insertion',
		name: 'insertion-validation',
		components: {
			DxButton,
			AudioTracker,
			creativeDetail,
			Loader,
			JoditEditor
		},
		props: {
			creativeId: VueTypes.string.def(null),
			email: VueTypes.string.def(null),
		},
		mixins: [],
		data() {
			return {
				isLoading: 0,
				playType: 0,
				isPlaying: false,
				playingSubInsertionsId: null,
				loadedSubInsertions: [],
				audioIsLoaded: false,
				creativeDetail: null,
				creative: null
			};
		},
		computed: {
			creativeName() {
				return this.creativeDetail?.creative?.RootCreativeName || this.creativeDetail?.creative?.Name;
			},
			audioTracker() {
				return this.creativeDetail?.$refs?.tracker;
			},
			insertionEditor() {
				return this.creativeDetail?.$refs?.insertionEditor;
			},
			insertionEditorDetails() {
				return this.insertionEditor.$refs?.details;
			},
			actionsDisabled() {
				return !!this.isLoading || !!this.isPlaying || !this.audioIsLoaded;
			},
			creativeTracks() {
				return this.creativeDetail?.loadedTracks;
			},
			validationAvailable() {
				return new Date(this.creativeDetail?.creative?.ValidationDueDate) > new Date();
			},		
		},
		mounted() {
			if (__DEBUG__)
				window.validation = this;
			this.$eventsBus
				.$on('audio-tracker-play', this.onPlay)
				.$on('audio-tracker-stop', this.onStop);
		},
		beforeDestroy() {
			this.$eventsBus
				.$off('audio-tracker-play', this.onPlay)
				.$off('audio-tracker-stop', this.onStop);
		},
		methods: {
			applyInsertionChanges(insertion) {
				if (!this.validationAvailable) return;
				const track = this.getCreativeTrack(insertion);
				if (!track) return;
				track.insertion.Ssml = insertion.Ssml;
				this.$set(insertion, '__isLoading', true);
				this.getCreativeTrack(insertion)?.__regenerate()?.finally(() => {
					this.$set(insertion, '__isLoading', false);
					this.playInsertion(insertion);
				});
			},
			getCreativeTrack(insertion) {
				return this.creativeDetail?.visibleTracks?.find(f => f.id === insertion?.Oid) || { insertion };
			},
			onPlay() {
				this.isPlaying = true;
			},
			onStop() {
				this.isPlaying = false;
			},
			onCreativeInitialized() {
				this.creativeDetail = this.$refs?.creativeDetail;
				this.creative = this.creativeDetail?.creative;
			},
			onTrackerLoaded(v) {
				if (v && !this.audioIsLoaded) {
					this.audioIsLoaded = v;

					setImmediate(() => {
						if (this._isDestroyed) return;
						if (this.validationAvailable) {
							this.getSsmlInsertions().then(() => {
								this.initSubInsertions();
							});
						}
					});
				}
			},
			async initSubInsertions() {
				this.isLoading++;
				try {
					await Promise.all(this.loadedSubInsertions.map(f => {
						let parentTrack = this.audioTracker?.tracks?.find(t => t.id === f.ParentId);
						return parentTrack.__loadSubTrack(f.Oid);
					}));
					
					this.audioTracker.soloSubTrackIds = this.loadedSubInsertions.map(f => f.Oid);
				} finally {
					this.isLoading--;
				}
			},
			getSsmlInsertions() {
				this.isLoading++;
				return this.$Data
					.getSsmlInsertionsByEmail(this.creativeId)
					.then((r) => {
						this.loadedSubInsertions = r.Results;
						return this.loadedSubInsertions;
					})
					.finally(() => this.isLoading--);
			},
			playMix() {
				this.playingSubInsertionsId = null;
				this.playType = 2;
				this.audioTracker.togglePlay();
			},
			stopPlayMix() {
				this.playType = 0;
				this.audioTracker.stop();
			},
			async playInsertion(insertion) {
				this.isPlaying = true;
				this.playType = 1;
				this.playingSubInsertionsId = insertion?.Oid;
				if (insertion) {
					const track = this.audioTracker?.tracks?.find(f => f.id === insertion?.Oid);
					this.audioTracker?.play(0, {
						tracks: [track],
						solo: true
					});
				} else {
					this.audioTracker?.play(0);
				}
			},
			stopPlaySubInsertions() {
				this.isPlaying = false;
				this.playType = 0;
				this.playingSubInsertionsId = null;
				this.audioTracker.stop();
			},
			downloadMix() {
				this.audioTracker.downloadFinalAudio();
			},
			formatTime(sec) {
				var sec_num = Math.floor(sec);
				var hours   = Math.floor(sec_num / 3600);
				var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
				var seconds = sec_num - (hours * 3600) - (minutes * 60);

				if (hours != 0) {
					if (hours   < 10) {hours   = "0" + hours;}
					hours += ':'
				} else {
					hours = '';
				}
				if (minutes < 10) {minutes = "0" + minutes;}
				if (seconds < 10) {seconds = "0" + seconds;}
				return hours + minutes + ':' + seconds;
			}
		},
	}
</script>

<style lang='scss' scoped>
	.insertion-validation {
		display: block;

		&-editor {
			display: block;
			padding: 0 20px;
		}

		.validation-ssml-editor {
			height: 100px;
		}
	}
</style>
